<template>
  <div class="bids-list tab-table p-2">
    <BidsTable :exclude-columns="computedExcludeColumns" :exclude-search-fields="excludeSearchFields"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import BidsTable from "@/modules/bids/BidsTable";

  const {mapState} = createNamespacedHelpers('reservations');
  const {mapActions: bidsMapActions} = createNamespacedHelpers('bids');

  export default {
    name: "BidsView",
    components: {BidsTable},
    data() {
      return {
        excludeColumns: ['stock_no'],
        excludeSearchFields: ['stock_no', 'is_winner', 'lot_no'],
      }
    },
    computed: {
      ...mapState({
        reservation: state => state.view.currentReservation,
        sale: state => state.view.currentReservation.auction
      }),
      computedExcludeColumns() {
        const excludeColumns = _.cloneDeep(this.excludeColumns);
        return this.sale.type === 'timed' ? excludeColumns : [...excludeColumns, 'actions'];
      },
    },
    methods: {
      ...bidsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      if (this.reservation.lot_no) {
        await this.updateTableSource({
          source: 'reservationView',
          extraFilters: {lot_uuid: this.reservation.lot.uuid},
          sale: this.sale,
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
